import { FC } from "react";
import GenericCrudTable from "@/components/tables/genericCrudTable";
import { getRecordMetadataColumns } from "@/components/tables/recordMetadataColumns";
import { useTranslation } from "react-i18next";
import { usePageHeading } from "@/helper/customHooks/usePageHeading";

const TeamsTable: FC = () => {
  const { t } = useTranslation();
  usePageHeading(t("teams"));
  return (
    <GenericCrudTable
      allowColumnFiltering={true}
      showColumnFilterbyDefault={true}
      entity="team"
      columns={[
        { header: t("id"), accessorKey: "id", id: "id" },
        {
          header: t("name"),
          accessorKey: "name",
          id: "name",
          enableForCreate: true,
        },
        {
          header: t("description"),
          accessorKey: "description",
          id: "description",
          enableForCreate: true,
        },
        ...getRecordMetadataColumns(t, [
          "created_on",
          "created_by",
          "modified_on",
          "modified_by",
        ]),
      ]}
    />
  );
};

export default TeamsTable;
